import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/SetPassword";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell title="Forgot your password?" subtitle="Enter your work email and we'll send you a link to set a new one.">
      {sent ? (
        <div data-testid="forgot-sent" className="flex gap-2 rounded-md bg-emerald-50 px-3 py-3 text-sm text-emerald-800"><MailCheck className="h-4 w-4 shrink-0" />{sent}</div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5"><Label>Email</Label><Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          {err && <div data-testid="forgot-error" className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
          <Button data-testid="forgot-submit" type="submit" className="w-full" disabled={busy}>{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Send reset link</Button>
        </form>
      )}
      <Link to="/login" className="block text-sm font-medium text-indigo-600 hover:underline" data-testid="back-to-login">Back to sign in</Link>
    </AuthShell>
  );
}
